module.exports = __webpack_public_path__ + "img/45e70d36ebddef73ce4e39d2e100475f.9a566fa8.png";